<template lang="html">
  <div class="normal-header">
       <div class="v-header">
         <span class="back" @click="goBack()">
             <img src="../assets/common/common_btn_left_big@2x.png" alt="">
         </span>
         <span class="title">{{title}}</span>
        <span class="button">
            <slot></slot>
        </span>
      </div>
  </div>
</template>

<script>
export default {
  name: 'normalHeader',
  props: ['title','isH5'],
  data(){
    return {
    }
  },
  created(){

  },
  methods: {
    goBack() {
    if(this.isH5) {
        this.$router.go(-1)
    } else {
        this.$call.goBack();
    }
    }
  }
}
</script>

<style lang="css" scoped>
.normal-header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 100;
}
.v-header {
    /* padding: .27rem .27rem .27rem .16rem; */
    /*height: 50px;*/
    /*line-height: 50px;*/
    /*position: relative;*/
    /*font-size: 0.36rem;*/
    /*text-align: center;*/
    height: 50px;
    line-height: 50px;
    font-size: 0.36rem;
    /*text-align: center;*/
}
.v-header>span {
    /*display: inline-block;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*-webkit-transform: translateY(-50%);*/
    /*transform: translateY(-50%);*/
}
.back {
  /*display: inline-block;*/
  width: .6rem;
  height: .6rem;
  margin-left: .16rem;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.back img {
    width: 100%;
    height: 100%;
    vertical-align: top;
}
.title{
  display: inline-block;
  width: calc(100% - 1.16rem);
  box-sizing: border-box;
  padding: 0 .16rem;
  position: relative;
  left: .76rem;
  right: .27rem;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.button {
  font-size: 0.28rem;
  color: #777779;
  display: inline-block;
  position: absolute;
  right: .3rem;

}
</style>




// WEBPACK FOOTER //
// src/components/normalHeader.vue